import { Injectable } from '@angular/core';
import { dbConst } from './databaseConstants';
import { FirestoreCrudService } from './crudService';
import { AuthService } from '../auth.service';
import { collection, collectionData, Firestore, query, where } from '@angular/fire/firestore';
import { Observable, tap } from 'rxjs';
import { ITower } from 'app/models/tower';
import { ITap } from 'app/models/tap';

@Injectable({
  providedIn: 'root'
})
export class TowerService {
  private crudService: FirestoreCrudService<ITower>;
  constructor(
    private firestore: Firestore,
    authService: AuthService) {
    this.crudService = new FirestoreCrudService<ITower>(firestore, authService, dbConst.towers);
  }

  public triggerActive = false;

  getNewId(): string {
    return this.crudService.getNewId();
  }

  async add(item: ITower, id: string | undefined = undefined) {
    return await this.crudService.add(item, id);
  }

  async update(item: ITower) {
    return await this.crudService.update(item);
  }

  async softUpdate(id: string, item: any, uid: string) {
    return await this.crudService.softUpdate(id, item, uid);
  }

  async delete(id: string) {
    await this.crudService.delete(id);
  }

  getItem(id: string) {
    return this.crudService.get(id)
  }

  getItems(barId: string) {
    return this.crudService.getItemsOrder(barId);
  }

  getTaps(towerId: string) {
    const listRef = collection(this.firestore, dbConst.taps);
    const q = query(listRef, where('towerId', '==', towerId));
    return collectionData(q, { idField: 'id' }) as Observable<ITap[]>;
  }

}
